import { CustomError } from './customError';

export class RestClientError extends CustomError {
    public details?: unknown;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(url: string, restError: any = {}) {
        const message = `REST Client Error at ${url}${
            restError?.message ? `: ${restError?.message}` : ''
        }`;
        super(message, restError, restError.stack);
    }
}
